/**
 * Data attribute used to identify the render root element.
 * This allows resource links to be placed outside the render boundary.
 */
export const SFS_RENDER_ROOT_ATTR = "data-sfs-root";

/**
 * Data attribute used to store the instance ID on the render root element.
 * This enables per-instance prop isolation when multiple forms exist on the same page.
 */
export const SFS_INSTANCE_ID_ATTR = "data-sfs-instance-id";
